var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44752_13585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.332 9.33594V1.33594",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0013 12.0774L6.66797 9.33073H2.7813C2.57431 9.33073 2.37016 9.28254 2.18502 9.18997C1.99988 9.0974 1.83883 8.96299 1.71464 8.7974C1.59044 8.6318 1.5065 8.43956 1.46948 8.23591C1.43245 8.03226 1.44334 7.82278 1.5013 7.62406L3.05464 2.29073C3.13541 2.01378 3.30384 1.77049 3.53464 1.5974C3.76543 1.4243 4.04614 1.33073 4.33464 1.33073H13.3346C13.6883 1.33073 14.0274 1.47121 14.2774 1.72125C14.5275 1.9713 14.668 2.31044 14.668 2.66406V7.9974C14.668 8.35102 14.5275 8.69016 14.2774 8.9402C14.0274 9.19025 13.6883 9.33073 13.3346 9.33073H11.4946C11.2466 9.33086 11.0035 9.40019 10.7927 9.53092C10.5819 9.66164 10.4117 9.84859 10.3013 10.0707L8.0013 14.6641C7.68692 14.6602 7.37748 14.5853 7.0961 14.445C6.81472 14.3047 6.56868 14.1027 6.37637 13.8539C6.18405 13.6052 6.05042 13.3162 5.98548 13.0086C5.92053 12.701 5.92594 12.3826 6.0013 12.0774Z",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44752_13585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 -1 16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbsDown.b02c6e03a5b349b5567b179a130432d9.svg";
export { ForwardRef as ReactComponent };